import {useLocation} from 'react-router';
export function useURLQuery() {
  const location = useLocation();

  const data: any = Object.fromEntries(new URLSearchParams(location.search));
  return data;
}
